import { render, staticRenderFns } from "./DiscoveryFilterTagsController.vue?vue&type=template&id=b7863d3e&"
import script from "./DiscoveryFilterTagsController.vue?vue&type=script&lang=ts&"
export * from "./DiscoveryFilterTagsController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports